var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9055 9.23706L7.1279 5.56984H8.70904L9.93145 9.23706L13.5987 10.4595V12.0406L9.93145 13.263L8.70904 16.9302H7.1279L5.9055 13.263L2.23828 12.0406V10.4595L5.9055 9.23706ZM7.91847 8.4686L7.35487 10.1594L6.82783 10.6864L5.13704 11.25L6.82783 11.8136L7.35487 12.3407L7.91847 14.0315L8.48207 12.3407L9.00911 11.8136L10.6999 11.25L9.00911 10.6864L8.48207 10.1594L7.91847 8.4686Z",
    fill: "#5F6368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4607 4.29225L14.1108 2.34192H15.0595L15.7096 4.29225L17.6599 4.94236V5.89104L15.7096 6.54115L15.0595 8.49148H14.1108L13.4607 6.54115L11.5104 5.89104V4.94236L13.4607 4.29225Z",
    fill: "#5F6368"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.b48315dda1ae5ea0472218bf90c8781f.svg";
export { ForwardRef as ReactComponent };